// extracted by mini-css-extract-plugin
export default {"answerWrapper":"QuizAnswer-modules__answerWrapper__qZ_eJ","isCorrect":"QuizAnswer-modules__isCorrect__k2UTK"};